import MarkdownContent from "features/markdown/elements/MarkdownContent";
import { useIsMobile } from "hooks/useIsMobile";
import React, { memo, ReactNode } from "react";
import ReactModal from "react-modal";

import type { ModalWindowProps } from "./ModalWindow.types";
import { DEFAULT_OVERLAY_COLOR, modifyOverlayColor } from "./ModalWindow.utils";

import "./ModalWindow.css";

const ModalContent: React.FC<{ wrapContent: boolean; children: ReactNode }> = ({
  wrapContent,
  children,
}) =>
  wrapContent ? (
    <div className="modal-content-wrapper">{children}</div>
  ) : (
    <>{children}</>
  );

const ModalWindow: React.FC<ModalWindowProps> = ({
  overlayTitle = <></>,
  title = <></>,
  content = <></>,
  content2 = null,
  isModalOpen = false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsModalOpen = () => {},
  overlayColor,
  wrapContent = false,
  showCloseBtn = true,
}) => {
  const { isMobile } = useIsMobile();
  const backgroundColor = overlayColor
    ? modifyOverlayColor(overlayColor)
    : DEFAULT_OVERLAY_COLOR;

  const content2Block =
    typeof content2 === "string" ? (
      <MarkdownContent content={content2} />
    ) : (
      content2
    );

  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <div className="modal">
      <ReactModal
        appElement={document.getElementById("root") || undefined}
        shouldCloseOnOverlayClick={false}
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: { zIndex: 1000, backgroundColor },
          content: {
            border: "none",
            padding: 0,
            inset: "40px 24px 24px",
            borderRadius: "8px",
            overflow: overlayTitle ? "visible" : "hidden",
            maxWidth: isMobile ? "100vw" : content2 ? "1200px" : "600px",
            margin: "0 auto",
            height: "auto",
          },
        }}
        contentLabel="Example Modal"
      >
        {!!overlayTitle && (
          <div className="modal-overlay-title">{overlayTitle}</div>
        )}

        {showCloseBtn && (
          <span
            className="modal-btn-close"
            onClick={closeModal}
          >
            ×
          </span>
        )}

        {title && <h4 className="modal-title">{title}</h4>}

        {content2 && !isMobile ? (
          <div className="modal-double-content">
            <div>
              <ModalContent wrapContent={wrapContent}>{content}</ModalContent>
            </div>
            <div className="modal-content-right">{content2Block}</div>
          </div>
        ) : (
          <ModalContent wrapContent={wrapContent}>{content}</ModalContent>
        )}
      </ReactModal>
    </div>
  );
};

export default memo(ModalWindow);
